export enum RadiusTokenType {
  ComponentLarge = 'component-radius-large',
  ComponentStandard = 'component-radius-standard',
  ComponentMedium = 'component-radius-medium',
  ComponentSmall = 'component-radius-small',
  Xs = 'radius-xs',
  Xl2 = 'radius-2xl',
  Full = 'radius-full',
}
